import React, { useState, useEffect } from "react";
import {
  Card,
  CardHeader,
  CardBody,
  Row,
  Col,
  FormGroup,
  Label,
  Button,
} from "reactstrap";
import Select from "react-select";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/flatpickr.css";
import CampaignService from "../../../services/OrderingServices/CampaignService";

const CampaignStatsFilterCard = ({
  filters,
  handleFilterChange,
  handleClearFilters,
  setCurrentPage,
}) => {
  const [campaignOptions, setCampaignOptions] = useState([]);
  const [loadingCampaigns, setLoadingCampaigns] = useState(false);

  // Fetch campaigns on component mount
  useEffect(() => {
    fetchCampaigns();
  }, []);

  const fetchCampaigns = async () => {
    try {
      setLoadingCampaigns(true);
      const response = await CampaignService.campaignsList({
        pageNumber: 1,
        pageSize: 1000, // Fetch all campaigns
      });

      // Handle both array directly and object with data property
      const campaignsList = Array.isArray(response)
        ? response
        : response?.data || [];

      if (campaignsList && campaignsList.length > 0) {
        const options = campaignsList.map((campaign) => ({
          value: campaign.id,
          label: campaign.name,
        }));
        setCampaignOptions(options);
      }
    } catch (error) {
      console.error("Error fetching campaigns:", error);
    } finally {
      setLoadingCampaigns(false);
    }
  };

  const handleCampaignChange = (selectedOption) => {
    handleFilterChange(
      "campaignId",
      selectedOption ? selectedOption.value : "",
    );
  };

  return (
    <>
      <Row className="">
        <Col lg="12">
          <Card className="border-0 shadow-sm">
            <CardHeader className="bg-light">
              <Row className="align-items-center justify-content-between w-100">
                <Col md="auto">
                  <h5 className="mb-0 d-flex align-items-center gap-2">
                    <i className="bx bx-filter-alt"></i> Search & Filter
                  </h5>
                </Col>

                <Col md="auto" className="d-flex gap-2">
                  <Button
                    color="secondary"
                    outline
                    size="sm"
                    onClick={handleClearFilters}
                  >
                    <i className="bx bx-reset me-2"></i>Clear All
                  </Button>
                </Col>
              </Row>
            </CardHeader>

            <CardBody>
              <Row className="g-3">
                {/* Campaign Name Dropdown */}
                <Col md="3">
                  <FormGroup className="mb-0">
                    <Label className="small fw-bold d-block mb-2">
                      Campaign
                    </Label>
                    <Select
                      options={campaignOptions}
                      value={
                        filters.campaignId
                          ? campaignOptions.find(
                              (option) => option.value === filters.campaignId,
                            )
                          : null
                      }
                      onChange={handleCampaignChange}
                      placeholder="Choose a campaign..."
                      isClearable
                      isLoading={loadingCampaigns}
                      classNamePrefix="react-select"
                    />
                  </FormGroup>
                </Col>

                {/* Date Range */}
                <Col md="3">
                  <FormGroup className="mb-0">
                    <Label className="small fw-bold d-block mb-2">
                      Start Date - End Date
                    </Label>

                    <div style={{ position: "relative", zIndex: 10 }}>
                      <Flatpickr
                        value={[filters.startDate, filters.endDate]}
                        onChange={(dates) => {
                          if (dates.length === 2) {
                            handleFilterChange("startDate", dates[0]);
                            handleFilterChange("endDate", dates[1]);
                          }
                        }}
                        options={{
                          mode: "range",
                          enableTime: true,
                          dateFormat: "Y-m-d H:i",
                          closeOnSelect: false,
                        }}
                        className="form-control form-control-md w-100"
                        placeholder="Start - End Date"
                      />
                    </div>
                  </FormGroup>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default CampaignStatsFilterCard;
